<cam-files-display
  [files$]="this.getDocs$()"
  [menu]="this.menu"
  [canAddFile]="this.canAddFile()"
  fileType="Document"
  (fileSelected)="this.downloadDocument($event)"
  (moreInformationSelected)="this.openBottomSheet($event)"
  (fileUploading)="this.uploadDocuments($event)"
>
</cam-files-display>

<cam-layout-full-panel
  [toggleState]="this.uploadModal.open()"
  (closeEvent)="this.uploadModal.open.set(false)"
  title="core.documents.upload.title"
  type="modal"
  size="lg"
>
  @if (this.uploadModal.open()) {
    <cam-upload-document-content
      [modalState]="this.uploadModal"
      (closeEvent)="this.onUploadSaved($event)"
    ></cam-upload-document-content>
  }
</cam-layout-full-panel>
